import _ from "lodash";
import {hasTag} from "@/helper/characteristic/Tag";

export function byId (id, items)
{
	let item = null;

	_.forEach(items, innerItem =>
	{
		if (innerItem.id === id)
		{
			item = innerItem;
		}

		if (!item && innerItem.children && innerItem.children.length > 0)
		{
			item = byId(id, innerItem.children);
		}

		if (item)
		{
			return false; // break
		}
	});

	return item;
}

export function byTag (items, tag)
{
	let item = null;

	_.forEach(items, innerItem =>
	{
		if (hasTag(innerItem, tag))
		{
			item = innerItem;
		}

		if (item)
		{
			return false; // break
		}
	});

	return item;
}

export function byIds (ids, items)
{
	let foundItems = [];

	_.forEach(ids, id =>
	{
		const item = byId(id, items);

		if (item)
		{
			foundItems.push(item);
		}
	});

	return foundItems;
}

export function getParent (id, items)
{
	let parent = null;

	_.forEach(items, innerItem =>
	{
		const childIds = _.map(innerItem.children, 'id')

		// has no children, cannot be a parent
		if (childIds.length === 0)
		{
			return true; // continue
		}

		if (_.includes(childIds, id))
		{
			parent = innerItem;
		}

		if (!parent && innerItem.children.length > 0)
		{
			parent = getParent(id, innerItem.children);
		}

		if (parent)
		{
			return false; // break
		}
	});

	return parent;
}

export function getParents (id, items)
{
	let parents = [];

	let currentId = id;

	while (true)
	{
		const parent = getParent(currentId, items);

		if (!parent)
		{
			break;
		}

		parents.push(parent);

		currentId = parent.id;
	}

	return _.reverse(parents);
}

export function isParentOf (possibleParent, child, characteristicItems)
{
	const parentIds = _.map(getParents(child.id, characteristicItems), 'id');

	return _.includes(parentIds, possibleParent.id);
}

export function getSpecificityById (specificityId, items, specificityType)
{
	if (specificityType)
	{
		const alloc = _.find(
			specificityType.allocations,
			alloc => alloc.specificity.id === specificityId
		);

		if (alloc)
		{
			return alloc.specificity;
		}
	}

	let specificity = null;

	_.forEach(items, item =>
	{
		const alloc = _.find(item.specificities, alloc => alloc.specificity.id === specificityId);

		if (alloc)
		{
			specificity = alloc.specificity;

			return false; // break
		}

		const childSpecificity = getSpecificityById(specificityId, item.children || []);

		if (childSpecificity)
		{
			specificity = childSpecificity;

			return false; // break;
		}
	});

	return specificity;
}

export function getSpecificityType (specificityTypeId, characteristicType)
{
	const alloc = _.find(
		characteristicType.specificityTypes,
		alloc => alloc.specificityType.id === specificityTypeId
	);

	return alloc ? alloc.specificityType : null;
}

export function getChildIdsToLastLevel (characteristic, items)
{
	let childIds = _.map(characteristic.children, 'id');

	_.forEach(characteristic.children, child =>
	{
		childIds = _.concat(
			childIds,
			getChildIdsToLastLevel(child, items)
		);
	});

	return childIds;
}
